export default "__VITE_ASSET__DCZPBKF9__"